module.exports = __webpack_public_path__ + "static/media/AV Level 3.61ef56c3.svg";